// write by cursor
// 生成时间: 2025-07-29 16:45:55
// Endpoint域名映射管理器

import { EndpointMapping } from '../types/request';
import { REGION_API_DOMAIN_MAP } from '../config/region';

/**
 * Endpoint域名映射管理 - write by cursor
 */
export class EndpointManager {
  private endpointMapping: EndpointMapping = REGION_API_DOMAIN_MAP;
  
  /**
   * 设置默认域名 - write by cursor
   */
  private defaultDomain: string;

  constructor(defaultDomain: string) {
    this.defaultDomain = defaultDomain;
  }

  generateDomain(domain: string): string {
    if (domain.startsWith('https://') || domain.startsWith('http://')) {
      return domain;
    }
    return `https://${domain}`;
  }
  
  /**
   * 根据endpoint获取对应的域名 - write by cursor
   * @param endpoint - 机器人的endpoint字段
   * @returns 对应的域名
   */
  getDomain(endpoint?: string): string {
    if (!endpoint) {
      return this.generateDomain(this.defaultDomain); // 默认域名
    }

    const domain = this.endpointMapping[endpoint] || 'bot.gs-robot.com';

    return this.generateDomain(domain);
  }

  /**
   * 构建完整的API URL - write by cursor
   * @param path - API路径或完整URL  
   * @param endpoint - 可选的endpoint
   * @returns 完整的API URL
   */
  buildUrl(path: string, endpoint?: string): string {
    // 如果path已经是完整的URL（包含协议），直接返回 - write by cursor
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    
    // 否则拼接域名和路径 - write by cursor
    const domain = this.getDomain(endpoint);
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${domain}${cleanPath}`;
  }

  /**
   * 添加或更新 endpoint 映射 - write by cursor
   */
  setEndpointMapping(endpoint: string, domain: string): this {
    this.endpointMapping[endpoint] = domain;
    return this;
  }

  /**
   * 批量设置 endpoint 映射 - write by cursor
   */
  setMappings(mappings: EndpointMapping): this {
    this.endpointMapping = { ...this.endpointMapping, ...mappings };
    return this;
  }
} 